import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Assessment Summary")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top 5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Phase", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Assessed Trainees", -1)
const _hoisted_13 = { class: "card p-3 position-relative" }
const _hoisted_14 = { class: "row m-0" }
const _hoisted_15 = { class: "col bg-light-success d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-2x text-success" })
], -1)
const _hoisted_18 = { class: "col mt-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-bold fs-7 mt-2" }, "Course(s) Assessed", -1)
const _hoisted_20 = { class: "col bg-light-primary d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-2x text-primary" })
], -1)
const _hoisted_23 = { class: "col mt-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bold fs-7 mt-2" }, "Batch(es) Assessed", -1)
const _hoisted_25 = { class: "col bg-light-info d-flex align-items-center px-1 py-8 rounded-2 me-4" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mx-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-2x text-info" })
], -1)
const _hoisted_28 = { class: "col mt-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-info fw-bold fs-7 mt-2" }, "Trainee(s) Assessed", -1)
const _hoisted_30 = { class: "col bg-light-danger d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-danger d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-2x text-danger" })
], -1)
const _hoisted_33 = { class: "col mt-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold fs-7 mt-2" }, "Trainee(s) Dropout", -1)
const _hoisted_35 = { class: "col bg-light-warning d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-2x text-warning" })
], -1)
const _hoisted_38 = { class: "col mt-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-warning fw-bold fs-7 mt-2" }, "Trainee(s) Absent", -1)
const _hoisted_40 = { class: "col bg-light-success d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-2x text-success" })
], -1)
const _hoisted_43 = { class: "col mt-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-bold fs-7 mt-2" }, "Assessor Involved", -1)
const _hoisted_45 = { class: "col bg-light-info d-flex align-items-center px-3 py-8 rounded-2" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock fs-2x text-info" })
], -1)
const _hoisted_48 = { class: "col mt-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "text-info fw-bold fs-7 mt-2" }, "Assessment Dues (> 30)", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end col mt-4",
  "data-kt-industry-table-toolbar": "base"
}, null, -1)
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "card mb-5 mb-xl-10" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_54 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_55 = { class: "collapse show" }
const _hoisted_56 = { class: "card-body border-top p-9" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", {
  class: "current",
  "data-kt-stepper-element": "content"
}, null, -1)
const _hoisted_58 = { class: "table-responsive mt-5" }
const _hoisted_59 = { class: "table table-borderless gy-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Logo"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "Batch"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Assessed"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Dropout"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Absent"),
    /*#__PURE__*/_createElementVNode("th", null, "Female Assessed"),
    /*#__PURE__*/_createElementVNode("th", null, "Assessor"),
    /*#__PURE__*/_createElementVNode("th", null, "Dues over 30 days")
  ])
], -1)
const _hoisted_61 = { style: {} }
const _hoisted_62 = { class: "align-middle" }
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "align-middle" }
const _hoisted_65 = { class: "align-middle" }
const _hoisted_66 = { class: "align-middle" }
const _hoisted_67 = { class: "align-middle" }
const _hoisted_68 = { class: "align-middle" }
const _hoisted_69 = { class: "align-middle" }
const _hoisted_70 = { class: "align-middle" }
const _hoisted_71 = { class: "align-middle" }
const _hoisted_72 = { class: "align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Phase",
                  modelValue: _ctx.trainee.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                  filterable: "",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAssessmentDashboardCount())),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", null, [
              ((_ctx.showDashboardData == true))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("h5", _hoisted_18, _toDisplayString(Number(_ctx.assessmentDashboardCount?.course_assessed).toLocaleString()), 1),
                            _hoisted_19
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("h5", _hoisted_23, _toDisplayString(Number(_ctx.assessmentDashboardCount?.batch_assessed).toLocaleString()), 1),
                            _hoisted_24
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("h5", _hoisted_28, _toDisplayString(Number(_ctx.assessmentDashboardCount?.trainee_assessed).toLocaleString()), 1),
                            _hoisted_29
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("h5", _hoisted_33, _toDisplayString(Number(_ctx.assessmentDashboardCount?.trainee_dropout).toLocaleString()), 1),
                            _hoisted_34
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("h5", _hoisted_38, _toDisplayString(Number(_ctx.assessmentDashboardCount?.trainee_absent).toLocaleString()), 1),
                            _hoisted_39
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("h5", _hoisted_43, _toDisplayString(Number(_ctx.assessmentDashboardCount?.assessor_involved).toLocaleString()), 1),
                            _hoisted_44
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _createElementVNode("h5", _hoisted_48, _toDisplayString(_ctx.assessmentDashboardCount?.assessment_due), 1),
                            _hoisted_49
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_50,
                    (_ctx.showDashboardData == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("div", _hoisted_56, [
                                  _hoisted_57,
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("table", _hoisted_59, [
                                      _hoisted_60,
                                      _createElementVNode("tbody", _hoisted_61, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessmentDashboardData, (data, index) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: index,
                                            style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51)"}
                                          }, [
                                            _createElementVNode("td", _hoisted_62, _toDisplayString(index + 1), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("img", {
                                                src: 
                                            _ctx.api_url + data?.entity?.attach_file_info?.thumb_dir
                                          ,
                                                alt: "",
                                                width: "60"
                                              }, null, 8, _hoisted_63)
                                            ]),
                                            _createElementVNode("td", _hoisted_64, _toDisplayString(data?.entity?.entity_short_name), 1),
                                            _createElementVNode("td", _hoisted_65, _toDisplayString(data?.courses), 1),
                                            _createElementVNode("td", _hoisted_66, _toDisplayString(data?.batches), 1),
                                            _createElementVNode("td", _hoisted_67, _toDisplayString(Number(data?.trainee_assessed).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_68, _toDisplayString(Number(data?.trainee_dropout).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_69, _toDisplayString(Number(data?.trainee_absent).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_70, _toDisplayString(Number(data?.female_trainee).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_71, _toDisplayString(Number(data?.assessors).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_72, _toDisplayString(data?.assessment_dues), 1)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}